var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.2686V12.0046C19.999 13.7297 19.4404 15.4083 18.4075 16.79C17.3745 18.1718 15.9226 19.1826 14.2683 19.6717C12.6139 20.1608 10.8458 20.1021 9.22757 19.5042C7.60934 18.9064 6.22772 17.8015 5.28877 16.3542C4.34981 14.907 3.90383 13.195 4.01734 11.4736C4.13085 9.75223 4.79777 8.11364 5.91862 6.80224C7.03948 5.49083 8.55423 4.57688 10.2369 4.1967C11.9197 3.81651 13.6802 3.99045 15.256 4.69258",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6L12.3077 14L10 11.6024",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCheck);
export default __webpack_public_path__ + "static/media/backgroundCheck.2b008a9463801061763af69585ff112f.svg";
export { ForwardRef as ReactComponent };